<template>
	<div
		:id="blok._uid"
		class="flex flex-col items-center justify-start px-sm py-lg text-center"
	>
		<div
			class="relative flex items-center justify-around"
			:class="{'rounded-full bg-red-500': blok.has_background}"
		>
			<v-icon
				class="relative fill-red-500 text-10xl text-red-500 xl:text-12xl"
				:class="{'fill-white p-2 text-8xl text-white': blok.has_background}"
				:icon="iconName"
			/>
		</div>

		<v-h6 class="mt-md mb-xs">
			{{ blok.title }}
		</v-h6>

		<p class="hidden text-sm lg:block">
			{{ blok.ingress }}
		</p>
	</div>
</template>

<script setup lang="ts">
import type {BlokComponent} from "@pkg/shared/types";

const properties = defineProps<{
	blok: Extract<BlokComponent, {component: "sb-info" | "sb-info-item"}>;
}>();

const iconName = computed(() => properties.blok.icon);
</script>
